import { Box, Paper, Typography, styled, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import type { CommentDatesProps } from './ChatEvent/types';
import { formatBubbleDate } from './utils';

const DatesBox = styled(Paper)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: 5,
    transform: 'translateY(-50%)',
    zIndex: 10,
    padding: theme.spacing(0.5, 1),
    marginTop: theme.spacing(0.25),
    background: '#fff',
    borderRadius: 4,
    border: '1px solid #e0e0e0',
    boxShadow: 'none',
    width: 'fit-content',
    minWidth: 80,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
}));

const DateField = ({
    label,
    value,
    subtitle,
}: {
    label: string;
    value: string | null | undefined;
    subtitle?: string;
}) => (
    <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '0.75rem', mb: 0.2, '&:last-child': { mb: 0 } }}>
        <Typography
            variant="caption"
            sx={{
                whiteSpace: 'nowrap',
                fontWeight: 400,
                fontSize: '0.68rem',
                mr: 0.5,
            }}
            component="span"
        >
            {label}:
        </Typography>
        <Typography
            variant="body2"
            sx={{
                fontFamily: 'monospace',
                fontSize: '0.75rem',
                whiteSpace: 'nowrap',
                fontWeight: 400,
            }}
            component="span"
        >
            {value ? formatBubbleDate(value, false, true) : 'N/A'}
            {subtitle && <span style={{ marginLeft: 4, color: '#888', fontStyle: 'italic' }}>({subtitle})</span>}
        </Typography>
    </Box>
);

type Props = CommentDatesProps & { onClose?: () => void };

const CommentDates = ({ policyEvaluationEvents, onClose }: Props) => (
    <DatesBox>
        {onClose && (
            <IconButton
                size="small"
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    onClose();
                }}
                sx={{ position: 'absolute', top: -5, right: -5, zIndex: 11 }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        )}
        {policyEvaluationEvents?.map((ev: { label: string; date: string; subtitle?: string }, idx: number) => (
            <DateField key={idx} label={ev.label} value={ev.date} subtitle={ev.subtitle} />
        ))}
    </DatesBox>
);

export default CommentDates;
